import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { isEqual } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBicycle } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import MapUserTrip from "views/lib/components/maps/trip-map";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  actionFindAll,
  actionPaymentStatus,
  actionResetList,
  actionTaskTypes,
  actionGetTripById,
  actionResetTripById,
  actionEditDurationById,
  actionEditDurationResetLoading
} from "actions/action/actions";
import {
  getSingleBike,
} from "actions/bike/actions";
import ModalEditTrip from "./modal-edit-trip";

class UserTripHistory extends React.Component {
  constructor(props) {
    super(props);

    this.getColumns = this.getColumns.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSortedChange = this.handleSortedChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.handleLoadQr = this.handleLoadQr.bind(this);
    this.handleEditTripDurationModal = this.handleEditTripDurationModal.bind(this);

    this.state = {
      filters: [{
        fieldName: "user",
        fieldValue: this.props.userId,
        searchOperation: filterTypes.EQUALS.value
      }],
      page: 0,
      size: 100,

      bikeQrCollection: {}
    };

    this.props.actionTaskTypes();
    this.props.actionPaymentStatus();
    this.findAllRequest();
  }

  findAllRequest() {
    this.props.actionFindAll(this.state.page, this.state.size, "end,desc", this.state.filters);
  }

  componentWillUnmount() {
    this.props.actionResetList();
    this.props.actionResetTripById();
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.singleBike, this.props.singleBike)) {
      const bikeQrCollection = Object.assign({}, this.state.bikeQrCollection);
      if (!bikeQrCollection[nextProps.singleBike.id]) {
        bikeQrCollection[nextProps.singleBike.id] = nextProps.singleBike.qr;
        this.setState({
          bikeQrCollection
        });
      }
    }
  }

  getColumns = () => {
    const {
      taskTypes,
      paymentStatus
    } = this.props;
    return [
      {
        id: "bike-id",
        Header: "Bike",
        accessor: "id",
        Cell: ({ original }) => (
          <Link to={`/bikes/${original.bike}`}>
            {original.bike}
          </Link>
        ),
      },
      {
        id: "task",
        Header: "Task",
        accessor: "task",
        Cell: ({ original }) => (
          typeof original.task !== "undefined"
          && taskTypes[original.task]
            ? taskTypes[original.task]
            : "Not Set"
        ),
      },
      {
        id: "started",
        Header: "Start Date",
        accessor: "started",
        Cell: ({ original }) => (original.started
            ? moment(original.started)
              .format("HH:mm YYYY-MM-DD")
            : "Not Set"
        ),
        width: 135
      },
      {
        id: "finished",
        Header: "End Date",
        accessor: "finished",
        Cell: ({ original }) => (original.finished
            ? moment(original.finished)
              .format("HH:mm YYYY-MM-DD")
            : "Not Set"
        ),
        width: 135
      },
      {
        id: "distance",
        Header: "Distance",
        accessor: "distance",
      },
      {
        id: "bonused",
        Header: "Bonused",
        accessor: original => (original.bonused ? "Yes" : "No"),
      },
      {
        id: "holded",
        Header: "Holded",
        accessor: original => (original.holded ? "Yes" : "No"),
      },
      {
        id: "payment-amount",
        Header: "Payment Amount",
        Cell: ({ original }) => (original.payment && typeof original.payment.amount !== "undefined"
          ? original.payment.amount
          : 0)
      },
      {
        id: "payment-status",
        Header: "Payment Status",
        Cell: ({ original }) => (
          original.payment
          && original.payment.status
          && paymentStatus[original.payment.status]
            ? paymentStatus[original.payment.status]
            : "Not Set")
      }
    ];
  };

  handlePageChange = (page) => {
    this.setState({
      page
    }, this.handleLoad);
  };

  handleSortedChange = (sorted) => {
    this.setState({
      sort: `${sorted[0].id},${sorted[0].desc ? "desc" : "asc"}`
    }, this.handleLoad);
  };

  handlePageSizeChange = (size) => {
    this.setState({
      size,
      page: 0,
    }, this.handleLoad);
  };

  handleEditTripDurationModal = (id) => {
    const _self = this;
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: "Edit Trip Duration",
      children: (
        <ModalEditTrip
          tripId={id}
          onSubmit={(minutes) => {
            _self.props.actionEditDurationById(id, minutes);
            _self.props.closeCustomModal(modalObj);
            setTimeout(() => {
              _self.findAllRequest();
              _self.props.actionEditDurationResetLoading();
            }, 10000);
          }}
          onCancel={() => {
            _self.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => _self.props.closeCustomModal(modalObj)
    };
    _self.props.openCustomModal(modalObj);
  };

  handleLoad = () => {
    const {
      page,
      size,
      sort,
      filters
    } = this.state;

    this.props.actionFindAll(page, size, sort, filters);
  };

  handleLoadQr = (ev, item) => {
    ev.stopPropagation();
    this.props.getSingleBike(item.bike);
  };

  tripComponent(item) {
    const { bikeQrCollection } = this.state;
    return (
      <div className="position-relative trip g-pointer" onClick={() => this.selectTrip(item)}>
        <div className="tripMinutes">
          <div>
            <div className="count">
              {this.rideTime(item.start, item.end)}
            </div>
            <div className="title">
              minutes
            </div>
          </div>
        </div>
        <div className="tripDetails">
          <div className="tripDetailsBox">
            <div><i className="fas fa-circle"/> {item.start && moment(item.start)
              .format("HH:mm YYYY-MM-DD")} </div>
            <div className="details">
              {item.distance && <div>{item.distance / 1000} km</div>}
            </div>
            <div><i className="fas fa-circle"/> {item.end && moment(item.end)
              .format("HH:mm YYYY-MM-DD")} </div>
          </div>
          {item.payment &&
            <div className="payment">
              <div className="price">
                {item.payment.amount}
              </div>
              <div className="type">
                AMD
              </div>
              <div className="status">
                {this.paymentStatus(item.payment && item.payment.status)}

                {item.payment.status === "FAILED" && (
                  <button
                    className="btn btn-sm btn-danger ml-2"
                    onClick={() => this.handleEditTripDurationModal(item.id)}
                    title="Edit Duration"
                    disabled={this.props.editDurationLoading}
                  >
                    ED
                  </button>
                )}
              </div>
            </div>}
          {parseInt(item.bonus, 10)
            ? (
              <div className="bonused">
                {item.bonus} minutes from bonus
              </div>
            ) : null}
        </div>

        <div className="d-flex justify-content-center align-items-center position-absolute bg-success trip-bike">
          {bikeQrCollection[item.bike] || (
            <button
              className="btn btn-sm btn-warning btn-block"
              onClick={(ev) => this.handleLoadQr(ev, item)}
            >
              <FontAwesomeIcon icon={faBicycle} title="Bike"/> Get Bike QR
            </button>
          )}
        </div>
      </div>
    );
  }

  selectTrip = (item) => {
    this.props.actionResetTripById();
    this.props.actionGetTripById(
      item.bike,
      moment(item.start)
        .valueOf(),
      moment(item.end)
        .valueOf()
    );
  };

  paymentStatus = (type) => {
    switch (type) {
      case 0:
        return "Waiting";
      case 1:
        return "Paid";
      case 2:
        return "Rejected";
      case 3:
        return "Debt (multiple rejected)";
      case 4:
        return "Refunded";
      default:
    }
  };

  rideTime = (start, end) => Math.floor((end - start) / (60 * 1000));

  render() {
    const {
      actionList,
      singleTrip
    } = this.props;

    return (
      <div style={{
        height: "calc(100vh - 145px)"
      }}>
        <div className="row h-100">
          <div className="col-6 h-100">
            <div className="userActionsList">
              {(actionList.content || []).map((item, i) =>
                <div key={i}>
                  {this.tripComponent(item)}
                </div>)}
            </div>
          </div>
          <div className="col-6 h-100">
            {singleTrip.length ?
              <MapUserTrip
                pathCoordinates={singleTrip.map(item => ({
                  lng: item.position.coordinates[0],
                  lat: item.position.coordinates[1],
                }))}
              />
              : null}
          </div>
        </div>
      </div>
    );
  }
}

UserTripHistory.propTypes = {
  userId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  taskTypes: state.action.taskTypes,
  paymentStatus: state.action.paymentStatus,
  actionList: state.action.actionList,
  singleTrip: state.action.singleTrip,
  editDurationLoading: state.action.editDurationLoading,
  singleBike: state.bike.single,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  actionFindAll: bindActionCreators(actionFindAll, dispatch),
  actionPaymentStatus: bindActionCreators(actionPaymentStatus, dispatch),
  actionResetList: bindActionCreators(actionResetList, dispatch),
  actionTaskTypes: bindActionCreators(actionTaskTypes, dispatch),
  actionGetTripById: bindActionCreators(actionGetTripById, dispatch),
  actionResetTripById: bindActionCreators(actionResetTripById, dispatch),
  getSingleBike: bindActionCreators(getSingleBike, dispatch),

  actionEditDurationById: bindActionCreators(actionEditDurationById, dispatch),
  actionEditDurationResetLoading: bindActionCreators(actionEditDurationResetLoading, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserTripHistory);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-trip-history.js